module.exports = "<div class=\"popup-header\">\r\n\t<div class=\"popup-title\">${zde.lang('msg_product_added_to_the_cart')}</div>\r\n</div>\r\n<div class=\"popup-buttons\">\r\n\t<button type=\"button\" class=\"popup-btn active\" rel=\"close-dialog\">${zde.lang('btn_ir_continue')}</button>\r\n\t<a class=\"popup-btn active\" href=\"${site_url('cart')}\">${zde.lang('btn_ir_go_to_order_page')}</a>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./modules/packages/create_order/templates/cart-popup-success.html
// module id = mdy+
// module chunks = 2 3 4 5 6 11